<div>
    <div class="section-header">
        <div class="title">
            Endanwenderdaten
        </div>
    </div>
    <div bdFxLayout="row wrap" bdFxLayoutAlign="space-between center" *ngIf="model">
        <bd-labeled-input bdFxFlex="1 1 100%" label="Firma*" placeholder="Firma eingeben"
                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_NAME)}"
                          required
                          name="companyName" [(ngModel)]="model.project.company.name"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #companyNameNgModel="ngModel">
        </bd-labeled-input>
        <bd-input-error-viewer class="company-name-error-viewer" [ngModelRef]="companyNameNgModel">
        </bd-input-error-viewer>

        <app-branch-select [(ngModel)]="model.project.industrySector"
                           class="branch-select"
                           [ngClass]="{'notify-change' : notifyChange( pUNFEnum.INDUSTRY_SECTOR)}"
                           [label]="'Branche*'"
                           name="industrySector"
                           required
                           [forceFormValidationVisibility]="forceFormValidationVisibility"
                           #industrySectorNgModel="ngModel">
        </app-branch-select>
        <bd-input-error-viewer [ngModelRef]="industrySectorNgModel">
        </bd-input-error-viewer>

        <bd-labeled-input bdFxFlex="1 1 100%" label="Abteilung*" placeholder="Abteilung eingeben"
                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.DEPARTMENT)}"
                          required
                          name="department" [(ngModel)]="model.project.department"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #departmentNgModel="ngModel">
        </bd-labeled-input>
        <bd-input-error-viewer [ngModelRef]="departmentNgModel">
        </bd-input-error-viewer>

        <bd-labeled-select-input bdFxFlex="1 1 100%" label="Mitarbeiteranzahl*"
                                 placeholder="Bitte auswählen"
                                 required
                                 [ngClass]="{'notify-change' : notifyChange( pUNFEnum.EMPLOYEE_COUNT)}"
                                 [choices]="selects.employeeCountRange.choices"
                                 [values]="selects.employeeCountRange.values"
                                 name="employeeCountRange" [(ngModel)]="model.project.employeeCountRange"
                                 [forceFormValidationVisibility]="forceFormValidationVisibility"
                                 #employeeCountRangeNgModel="ngModel">
        </bd-labeled-select-input>
        <bd-input-error-viewer [ngModelRef]="employeeCountRangeNgModel">
        </bd-input-error-viewer>

        <bd-labeled-input bdFxFlex="1 1 100%" label="Straße, Nr.*" placeholder="Straße, Hausnummer"
                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_STREET)}"
                          required
                          name="COMPANY_STREET" [(ngModel)]="model.project.company.street"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #streetNgModel="ngModel">
        </bd-labeled-input>
        <bd-input-error-viewer [ngModelRef]="streetNgModel">
        </bd-input-error-viewer>

        <bd-labeled-input bdFxFlex="1 1 calc(25% - 9px)" label="PLZ*" placeholder="Postleitzahl" class="zip-code"
                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_ZIP) } "
                          required pattern="\d{4,5}"
                          name="zipCode" [(ngModel)]="model.project.company.zip"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #zipCodeNgModel="ngModel"
                          (ngModelChange)="onZipCodeChange(zipCodeNgModel, countryNgModel)">

        </bd-labeled-input>
        <!--    note: error viewer is downwards on the same row as error viewer for next input-->

        <bd-labeled-input bdFxFlex="1 1 calc(75% - 9px)" label="Ort*" placeholder="Ort" class="city"
                          [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_CITY)}"
                          required
                          name="COMPANY_CITY" [(ngModel)]="model.project.company.city"
                          [forceFormValidationVisibility]="forceFormValidationVisibility"
                          #cityNgModel="ngModel">
        </bd-labeled-input>


        <div class="errors-container" bdFxFlex="0 0 100%">
            <bd-input-error-viewer [ngModelRef]="zipCodeNgModel" [customErrorsMsg]="getZipErrorMessages()"
                                   class="zip-code">
            </bd-input-error-viewer>
            <bd-input-error-viewer [ngModelRef]="cityNgModel" class="city">
            </bd-input-error-viewer>
        </div>


        <bd-labeled-select-input bdFxFlex="1 1 100%" label="Land*" placeholder="Bitte auswählen"
                                 [ngClass]="{'notify-change' : notifyChange( pUNFEnum.COMPANY_COUNTRY)}"
                                 required
                                 [choices]="selects.country.choices"
                                 [values]="selects.country.values"
                                 name="country" [(ngModel)]="model.project.company.country"
                                 [forceFormValidationVisibility]="forceFormValidationVisibility"
                                 [appValueIsValidFn]="zipEqualsToCountryTestFn"
                                 #countryNgModel="ngModel">

        </bd-labeled-select-input>

        <bd-input-error-viewer [ngModelRef]="countryNgModel"
                               [customErrorsMsg]="{'appValueIsValidFn': 'Das ausgewählte Land passt nicht zur PLZ.'}">
        </bd-input-error-viewer>
    </div>
</div>


